import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Actions as FYORINACTIONS } from './store/fyorinActions'
import { format, addYears, set, parse } from 'date-fns';
import DatePicker from 'react-datepicker';
import FyorinLogo from './assets/fyorin-logo.svg'
import Spinner from "../../common/Spinner";
import ProgressBar from "../../common/ProgressBar";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

const FyorinPayments = ({
    period,
    employeesToSync,
    getEmployeesToSync,
    stage,
    setPaymentStage,
    syncEmployees,
    syncingStatus,
    employeesToSyncList,
}) => {

    const today = set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    const [transferDate, setTransferDate] = useState(today)
    const [forLater, setForLater] = useState()

    useEffect(() => {
        getEmployeesToSync(period.id)
    }, [])

    useEffect(() => {
        if (period) {
            const payDate = parse(period?.payDay, 'yyyy-MM-dd', new Date())
            setTransferDate(payDate > today ? payDate : today)
        }
    }, [period])

    const setReview = (forLater) => {
        setForLater(forLater)
        setPaymentStage()
    }

    switch (stage) {
        case 'Review': return (
            <div className="block-content" style={{ padding: 20 }}>
                {!forLater &&
                    <p style={{ textAlign: 'center' }}>You're about to send payments for this payroll to Fyorin</p>
                }

                {forLater &&
                    <div style={{ padding: 20, width: "50%" }}>
                        <div className="form-material" >
                            <label>Transfer Date</label>
                            <DatePicker
                                selected={transferDate}
                                onChange={(date) => setTransferDate(date)}
                                minDate={today}
                                maxDate={addYears(new Date(), 100)}
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                    </div>
                }

                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                    paddingBottom: 20
                }}>
                    {!employeesToSyncList ?
                        <Spinner style={{ height: '2rem', width: '2rem', margin: 0 }} className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right" />
                        :
                        <div>
                            <button className="btn btn-default" onClick={() => syncEmployees(period.id, forLater ? transferDate.toISOString() : new Date().toISOString())}>
                                <img src={FyorinLogo} style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                <div style={{ float: "left" }}>{employeesToSync && 'Sync & '}Pay Employees</div>
                            </button>
                        </div>
                    }
                </div>
                {employeesToSync &&
                    <p style={{ textAlign: 'center' }}><a><strong>{employeesToSync}</strong></a> employees require syncing</p>
                }
            </div>
        )
        case 'Syncing': return (
            <div className="block-content" style={{ padding: 40 }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                    paddingBottom: 20
                }}>
                    <div style={{ float: "left" }}>Syncing Employees</div>
                    <div style={{ marginLeft: 5, float: "left" }}>
                        <Spinner style={{ height: '2rem', width: '2rem', margin: 0 }} className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right" />
                    </div>
                </div>

                <ProgressBar percentage={syncingStatus} />

            </div>
        )
        case 'Sending': return (
            <div className="block-content" style={{ padding: 40 }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                    paddingBottom: 20
                }}>
                    <div style={{ float: "left" }}>Sending Payroll Information to Fyorin</div>
                    <div style={{ marginLeft: 5, float: "left" }}>
                        <Spinner style={{ height: '2rem', width: '2rem', margin: 0 }} className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right" />
                    </div>
                </div>

            </div>
        )
        case 'Done': return (
            <div className="block-content" style={{ padding: 20 }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                    paddingBottom: 20
                }}>
                    <img src={FyorinLogo} style={{ height: '4rem' }} />
                </div>
                <h3 style={{ textAlign: 'center' }}>Success!</h3>
                <p style={{ textAlign: 'center', margin: 0 }}>Your payments were sent successfully</p>
                <p style={{ textAlign: 'center' }}>Kindly confirm on Fyorin to finalise your payments</p>
            </div>
        )
        case 'Error': return (
            <div className="block-content" style={{ padding: 20 }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 20,
                }}>
                    <ExclamationTriangleIcon style={{ height: '4rem' }} />
                </div>
                <h3 style={{ textAlign: 'center' }}>An error has occurred</h3>
                <p style={{ textAlign: 'center' }}>Your payments have not been processed</p>
            </div>
        )
    }

    return (
        <div className="block-content" style={{ padding: 20 }}>
            <p style={{ textAlign: 'center' }}>You're about to send payments for this payroll to Fyorin. You can either send them now or schedule for a later date.</p>

            <div style={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: 20,
                paddingBottom: 20
            }}>
                <div style={{
                    width: "40%",
                    textAlign: 'center',
                }}>
                    <button className="btn btn-success" onClick={() => setReview(false)}>Pay Now</button>
                </div>
                <div style={{
                    flexGrow: 2,
                    alignSelf: 'center',
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                        <hr style={{
                            flexGrow: 1,
                            margin: 5
                        }} />
                        <span>or</span>
                        <hr style={{
                            flexGrow: 1,
                            margin: 5
                        }} />
                    </div>
                </div>

                <div style={{
                    width: "40%",
                    textAlign: 'center',
                }}>
                    <button className="btn btn-success" onClick={() => setReview(true)}>Schedule For Later</button>
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = (state, ownProps) => {
    const { fyorin } = state?.integration?.payment || {}
    return {
        employeesToSync: fyorin?.unsyncedEmployees?.length || null,
        employeesToSyncList: fyorin?.unsyncedEmployees,
        syncingStatus: fyorin?.syncingStatus,
        stage: fyorin?.stage,
        period: state?.company?.bankTransferModal?.period,
        isModalOpen: state?.company?.bankTransferModal?.isOpen,
    };
};

const mapDispatchToProps = dispatch => ({
    syncEmployees: (payPeriodId, transferDate) => dispatch(FYORINACTIONS.syncEmployees(payPeriodId, transferDate)),
    setPaymentStage: () => dispatch(FYORINACTIONS.setPaymentStage('Review')),
    getEmployeesToSync: (payPeriodId) => dispatch(FYORINACTIONS.getEmployeesToSync(payPeriodId))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FyorinPayments)